import { Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultResponseInterface } from '../model/response/default-response.interface';
import { AbstractApiController } from '../../../../../../../modules/api-module/api/abstract-api-controller';
import { Configuration } from '../../../../../../../modules/api-module/configuration';
import { CarsResponse } from '../model/response/cars-response';

@Injectable()
export class AdminCarsApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchList(
    filter = null,
    page = 1,
    limit = 15,
    order: {[key: string]: 'ASC' | 'DESC'}[] = [{carType: 'ASC'}]
  ) {
    return this.http.get<CarsResponse>(
      this.prepareListRequest(
        this.baseUrl + '/api/te/admin/v1/cars',
        page,
        limit,
        order,
        filter
      ),
      {headers: this.getAuthHeaders()}
    );
  }

  public save(request) {
    return this.http.post<DefaultResponseInterface>(
      this.baseUrl + '/api/te/admin/v1/cars',
      request,
      {headers: this.getAuthHeaders()}
    );
  }

  public update(id, request) {
    return this.http.put<DefaultResponseInterface>(
      this.baseUrl + `/api/te/admin/v1/cars/${id}`,
      request,
      {headers: this.getAuthHeaders()}
    );
  }

  public delete(id) {
    return this.http.delete<DefaultResponseInterface>(
      this.baseUrl + `/api/te/admin/v1/cars/${id}`,
      {headers: this.getAuthHeaders()}
    );
  }
  public generateContract(id) {
    return this.http.post<DefaultResponseInterface>(
      this.baseUrl + `/api/te/admin/v1/cars/${id}/generate-contract`,
      {},
      {headers: this.getAuthHeaders()}
    );
  }

  public fetchEnum() {
    return this.http.get<any>(
      this.baseUrl + '/api/te/admin/v1/cars/enum',
      {headers: this.getAuthHeaders()}
    );
  }
}
